<script lang="ts">
	import { LoginLayout } from '@Shelly/shelly-design-system';
	import { _ } from 'svelte-i18n';
	import type { Snippet } from 'svelte';
	import LangDropdown from './LangDropdown.svelte';

	interface Props {
		children?: Snippet;
		backgroundImgSrc?: string;
		logoUrl?: string;
		title?: string;
		subtitle?: string;
	}

	const {
		children,
		backgroundImgSrc = './images/loginBackground.jpeg',
		logoUrl = './images/shelly-logo.svg',
		title,
		subtitle,
	}: Props = $props();

	// Mirror shelly-app-3's LoginLayout: title = "EXPLORE THE POSSIBILITIES"
	// marketing tagline (HTML, with a highlighted "POSSIBILITIES" span);
	// subtitle = our OAuth-context line ("Connect a third-party service…"),
	// previously the title.
	const resolvedTitle = $derived(
		title ??
			$_('login_tagline_title', {
				default: 'EXPLORE THE <span class="text-bold text-white"> POSSIBILITIES </span>',
			}),
	);
	const resolvedSubtitle = $derived(
		subtitle ??
			$_('login_title_default', { default: 'Connect a third-party service to Shelly' }),
	);
</script>

<LoginLayout {backgroundImgSrc} {logoUrl} subtitle={resolvedSubtitle}>
	<svelte:fragment slot="title">{@html resolvedTitle}</svelte:fragment>
	<div slot="form" class="form-content">
		<div class="lng-bar">
			<LangDropdown />
		</div>
		{@render children?.()}
	</div>
</LoginLayout>

<style>
	.form-content {
		display: flex;
		flex-direction: column;
		width: 100%;
		max-width: 360px;
	}
	/* Matches shelly-app-3's LoginLayout.lng-bar pattern: right-align the
	   language picker at the top of the form pane and pull it up so it
	   sits inline with the first heading/field row instead of taking a
	   dedicated row of vertical space. */
	.lng-bar {
		display: flex;
		justify-content: flex-end;
		margin-bottom: -28px;
		position: relative;
		z-index: 2;
	}
</style>
